
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"20","fill":"none"}},[_c('path',{attrs:{"d":"M13.269 11.703H1.359V5.955A5.963 5.963 0 0 1 7.314 0a5.963 5.963 0 0 1 5.955 5.955v5.748zM3.735 8.536h7.163V5.955a3.584 3.584 0 0 0-3.58-3.58 3.584 3.584 0 0 0-3.58 3.58v2.581h-.003z","fill":"#6B6B6B"}}),_c('path',{attrs:{"d":"M7.316 19.794A7.314 7.314 0 0 1 0 12.48V8.14h14.631v4.339a7.314 7.314 0 0 1-7.315 7.315z","fill":"#FBD872"}}),_c('path',{attrs:{"d":"M8.967 12.26a1.65 1.65 0 1 0-2.56 1.373v1.955a.912.912 0 0 0 1.822 0v-1.955c.445-.292.738-.8.738-1.373z","fill":"#F6AF62"}})])
      }
    
      }
    